import { CSSObject } from '@emotion/react'
import React, { useState, useEffect, useRef } from 'react'
import { Asset } from '@opallabs/kuiper'
import { baseStyles } from '../../styles'
import { FacebookReelDisplayProps } from '../../types'
import { Overlay } from './Overlay'
import * as styles from './styles'

export const MobileSingle: React.FC<FacebookReelDisplayProps> = ({
  accountImage,
  accountName,
  assets,
  collabEnabled,
  collabAccount,
  content,
  contentCharacterLimit,
  contentPlaceholderText,
  isPresenting,
  location,
  readOnly,
  sound,
  truncate,
  onExpandAsset,
  onRemoveAsset,
  onUpdateContentOption,
  updateCoverAsset,
}) => {
  const footerRef = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const [isHovered, setIsHovered] = useState(false)
  const [assetBaseStyles, setAssetBaseStyles] = useState<CSSObject>(
    styles.contentAssetBase(false, styles.defaultFooterHeight, truncate)
  )
  const asset = assets.length > 0 ? assets[0] : null

  useEffect(() => {
    if (footerRef.current && containerRef.current) {
      setAssetBaseStyles(
        styles.contentAssetBase(false, footerRef.current.offsetHeight, truncate)
      )
    }
  }, [content, footerRef.current?.offsetHeight, truncate])

  return (
    <div
      css={baseStyles('mobileSingle', Boolean(asset))}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Overlay
        accountImage={accountImage}
        accountName={accountName}
        collabEnabled={collabEnabled}
        collabAccount={collabAccount}
        content={content}
        contentCharacterLimit={contentCharacterLimit}
        contentPlaceholderText={contentPlaceholderText}
        footerRef={footerRef}
        location={location}
        readOnly={readOnly}
        sound={sound}
        truncate={truncate}
        onUpdateContentOption={onUpdateContentOption}
        setIsHovered={setIsHovered}
      />
      {asset && (
        <div ref={containerRef} css={assetBaseStyles}>
          <Asset
            assetReference={asset}
            hasAssetOptions={true}
            preview={false}
            isHovered={isHovered}
            overrideStyles={{
              asset: styles.contentAsset,
              assetBase: styles.contentAsset,
            }}
            disableMediaControls={false}
            hasAssetOverlay={asset && (!readOnly || isPresenting)}
            updateCoverAsset={(val: string) => updateCoverAsset(val, asset.id)}
            onEmbiggen={() => onExpandAsset(asset.id)}
            onRemove={() => onRemoveAsset(asset.id)}
          />
        </div>
      )}
    </div>
  )
}
